export default {"src":"/_next/static/media/business.82207d2e.svg","height":608,"width":741};